import styled, { css } from 'styled-components';
import { Spacer, Color } from '@lux/tokens';

import { Screen, screenBiggerThan } from '@client/styles/styled-components/breakpoints';

export const Container = styled.div`
    position: relative;
    min-height: 60px;
    background-color: ${({ theme }) => theme.functionColor.function0};
    color: ${({ theme }) => theme.functionColor.function100};
    text-align: center;
    display: flex;
    align-items: center;
    ${screenBiggerThan(Screen.mobile)} {
        height: 99px;
    }
`;

export const Wrapper = styled.div`
    width: 100%;
    font-size: 1.3rem;
`;

export const RegularContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 15px;

    ${screenBiggerThan(Screen.mobile)} {
        padding: 0 12px 0 12px;
    }
`;

export const RegularTextContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 9px 0;

    ${screenBiggerThan(Screen.mobile)} {
        padding: 0;
    }
`;
